const founderQuotes = [
  {
    quote: "I've run hundreds of interview loops at companies from 1 to 10,000 people. The pattern is always the same: as teams scale, signal quality drops and trust drops with it.",
    name: 'Ashwin Balamohan',
    context: 'FAANG EM, ex-YC Startup CTO',
  },
  {
    quote: "I've seen startups add interview rounds because they didn't trust the data they already had. That's a systems problem, not a people problem.",
    name: 'Gobinthiran Kulendran',
    context: 'CEO, Huex',
  },
  {
    quote: "The best hiring decisions I've seen weren't made by the loudest voice in the room—they were made when everyone was looking at the same evidence.",
    name: 'Sahan Karunarathne',
    context: 'COO, Talport',
  },
]

export function Testimonials() {
  return (
    <section className="py-24 bg-[#fafafa]">
      <div className="mx-auto max-w-7xl section-padding">
        {/* Why we're building this */}
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-brand-100 text-brand-700 text-sm font-medium mb-6">
            Why We're Building This
          </div>
          
          <h2 className="text-3xl sm:text-4xl font-bold text-surface-900 mb-4">
            We've lived this problem
          </h2>
          <p className="text-lg text-surface-600 mb-10">
            JumpstoneHR comes from years of watching hiring break at scale—and believing it doesn't have to.
          </p>

          {/* Founder quotes */}
          <div className="grid md:grid-cols-3 gap-6 text-left">
            {founderQuotes.map((item) => (
              <div key={item.quote} className="card p-6">
                <p className="text-surface-600 mb-4 italic">
                  "{item.quote}"
                </p>
                <p className="text-sm font-medium text-surface-900">{item.name}</p>
                <p className="text-sm text-surface-500">{item.context}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
